import React from "react";
import {
  Box,
  Button,
  Stack,
  Typography,
  DeleteModal,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";
// import DeleteWarningModal from "./modals/DeleteWarningModal";

const DeleteWarningModalBox = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Delete Warning Modal
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          height={"300px"}
          language="js"
          value={`
          import { useState } from "react"
          import { Button, DeleteModal } from "convertupleads-theme"
          
          export default function PreviewModal() {
            const [open, setOpen] = useState(false)
            return (
              <div>
                <Button onClick={() => setOpen(true)}>
                  Open modal
                </Button>
                <DeleteModal
                  open={open}
                  onClose={() => setOpen(false)}
                  title='Are you sure, You want to delete this file?'
                  warningContent='You are able to leave this page without saving. All changes will be lost.'
                ></DeleteModal>
              </div>
            )
          }          
          `}
        >
          <Button onClick={handleOpen} color={"error"}>
            Open Delete warning modal
          </Button>
          <DeleteModal open={open} onClose={handleClose} />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default DeleteWarningModalBox;
